import React from 'react';
import { styled } from '@mui/system';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import { uniqueId } from 'lodash';
import { convertMoney } from '@/utils/convertMoney';
import { style } from '@/styles/globals';
import FlexTableRow from '@/components/FlexTableRow';
import WideTableCell from '@/components/WideTableCell';

const CTABooking = styled('div')`
  ${style.text.content.bold}
  text-align: center;
  color: ${style.color.product3};
  cursor: pointer;
`;

const getDataInSomeDate = (days: any) => {
  const sortedDays = days
    .filter((item: any) => !!item?.averageMinfare)
    .sort((a: any, b: any) => a?.averageMinfare - b?.averageMinfare);

  return sortedDays;
};

export default function FareInMonth({
  days,
  numberDayInMonth,
  routeName,
  onSearchFlight,
  isDesktop,
}: any) {
  const data = getDataInSomeDate(days);
  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        mt: '8px',
        boxShadow: 'none',
      }}
    >
      <Table
        sx={{}}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow
            sx={{
              background: 'white',
              border: 0,
            }}
          >
            <WideTableCell
              align="center"
              sx={{ whiteSpace: 'nowrap' }}
            >
              Hành trình
            </WideTableCell>
            <WideTableCell
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              Ngày
            </WideTableCell>
            <WideTableCell
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              {isDesktop ? 'Giá rẻ nhất' : 'Giá'}
            </WideTableCell>
            {isDesktop && (

            <WideTableCell
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            />
            )}
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {(data || [])?.slice(0, numberDayInMonth).map((row: any) => (
            <FlexTableRow
              key={uniqueId()}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <WideTableCell align="center">{routeName}</WideTableCell>
              <WideTableCell
                sx={{
                  fontWeight: '500',
                }}
                align="center"
              >
                {moment(row.date).format('DD/MM')}
              </WideTableCell>
              <WideTableCell align="center">
                <div>
                  {row?.averageMinfare
                    ? convertMoney(row?.averageMinfare)
                    : 'Đang cập nhật'}
                </div>
                {!isDesktop && (
                  <CTABooking
                    onClick={() => onSearchFlight({
                      depart: moment(row.date).toISOString(),
                      return: null,
                    })}
                  >
                    Đặt vé
                  </CTABooking>
                )}
              </WideTableCell>
              {isDesktop && (
                <WideTableCell align="center">
                  <CTABooking
                    onClick={() => onSearchFlight({
                      depart: moment(row.date).toISOString(),
                      return: null,
                    })}
                  >
                    Đặt vé
                  </CTABooking>
                </WideTableCell>
              )}
            </FlexTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
